import { PreloaderCloud } from '~components/Preloaders/PreloaderCloud/PreloaderCloud';
import { PreloaderHrtek } from '~components/Preloaders/PreloaderHrtek/PreloaderHrtek';
import { DeployEnvironments } from '~deploy-config/enviroments';

const preloaderComponents = {
  [DeployEnvironments.HRTek]: PreloaderHrtek,
  [DeployEnvironments.VkCloudRu]: PreloaderCloud,
  [DeployEnvironments.VkCloudKz]: PreloaderCloud,
} as const;

export const PreloaderUtils = {
  getPreloaderComponent: (deployEnv: DeployEnvironments) =>
    preloaderComponents[deployEnv] || function () {},
};
